export const ADD_NEW_JUDGE_TO_LIST = 'ADD_NEW_JUDGE_TO_LIST';

export const ADD_SELECTED_JUDGES_TO_PANEL = 'ADD_SELECTED_JUDGES_TO_PANEL';

export const DELETE_JUDGE_FROM_ADD_TO_PANEL_LIST = 'DELETE_JUDGE_FROM_ADD_TO_PANEL_LIST';

export const RESET_JUDGES_ADD_TO_PANEL_LIST = 'RESET_JUDGES_ADD_TO_PANEL_LIST';
